var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExplainReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40963",
    "data-name": "Group 40963",
    transform: "translate(-143 -423)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15547",
    "data-name": "Rectangle 15547",
    width: 24,
    height: 24,
    transform: "translate(143 423)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "analysis_1_",
    "data-name": "analysis (1)",
    transform: "translate(129.5 409.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43556",
    "data-name": "Group 43556",
    transform: "translate(15 15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43554",
    "data-name": "Group 43554",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37261",
    "data-name": "Path 37261",
    d: "M15,101.908v14.5H29.405v-3.832",
    transform: "translate(-15 -98.122)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37262",
    "data-name": "Path 37262",
    d: "M106.243,15h10.43v4.545",
    transform: "translate(-102.268 -15)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37263",
    "data-name": "Path 37263",
    d: "M18.975,15,15,18.786h3.975Z",
    transform: "translate(-15 -15)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_43555",
    "data-name": "Group 43555",
    transform: "translate(5.71 1.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37264",
    "data-name": "Path 37264",
    d: "M146.052,434.69V437.4h13.84v-2.257",
    transform: "translate(-146.052 -417.701)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37265",
    "data-name": "Path 37265",
    d: "M345.592,44.742h5.147V58.453",
    transform: "translate(-336.898 -44.742)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_3356",
    "data-name": "Line 3356",
    y1: 1.875,
    x2: 2.875,
    transform: "translate(17.835 23.625)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_43558",
    "data-name": "Group 43558",
    transform: "translate(20.71 18.436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43557",
    "data-name": "Group 43557",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3148",
    "data-name": "Ellipse 3148",
    cx: 5.408,
    cy: 5.396,
    rx: 5.408,
    ry: 5.396,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37266",
    "data-name": "Path 37266",
    d: "M326.854,278.049l4.644,4.634a1.625,1.625,0,0,0,2.294,0h0a1.616,1.616,0,0,0,0-2.289l-4.628-4.618",
    transform: "translate(-318.977 -267.849)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3357",
    "data-name": "Line 3357",
    y1: 2.289,
    x2: 2.294,
    transform: "translate(10.019 10.048)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_37267",
    "data-name": "Path 37267",
    d: "M158.318,215.458l3.837-2.552,1.34,1.854,2.443-1.854",
    transform: "translate(-157.784 -207.72)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplainReport);
export default __webpack_public_path__ + "static/media/explain-report.8849c4ce6a399aff794ba1be5bba93f9.svg";
export { ForwardRef as ReactComponent };